import React from "react";
import { useEffect, useState, useRef } from "react";
import useNotifications from "../hooks/useNotifications";
import NotificationPreviewModal from "./NotificationPreviewModal";
import NotificationDrawer from "./NotificationDrawer";
import NotificationMeta from "./NotificationMeta";
import { Link, useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Loader from "../utils/Loader";
import { userManualDownloadUrl, disclaimer } from "../utils/constants";
import moment from "moment";
import StepHeader from "../screens/registration/stepHeader";
import TabComponent from "./TabComponent";
import AdminDrawer from "./admin_module_drawer.js";
import AdminMobileDrawer from "./admin_module_mobile_drawer.js";
import ChangePassword2 from "../screens/user_login_auth/changePassword2";
import NetworkStatusIndicator from "./NetworkStatusIndicator";

const HeaderWithLogo = ({ changeSummaryPage }) => {
  const history = useNavigate();
  const navigate = useNavigate();

  const navigateTo = (page) => {
    if (changeSummaryPage) {
      changeSummaryPage(page);
    } else {
      window.dispatchEvent(new CustomEvent('vendorNavigate', { detail: page }));
    }
  };
  const [isLoading, setLoader] = useState(false);
  const [isMobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [isMobileMenuOpen2, setMobileMenuOpen2] = useState(false);
  const [showNotifications, setShowNotifications] = useState(false);
  const [isChangePasswordOpen, setChangePasswordOpen] = useState(false);
  const { notifications, unreadCount, markAllRead, previewItem, openPreview, closePreview, showDrawer, openDrawer, closeDrawer } = useNotifications();
  const notificationRef = useRef(null);
  const marqueeRef = useRef(null);
  const loadScripts = () => {
    // Your existing script loading logic
  };

  useEffect(() => {
    loadScripts();
    console.log(
      "Exhibition Logo---------------------->",
      sessionStorage.getItem("ExhibitionLogoSS")
    );
  }, []);

  const onLogoutClick = () => {
    localStorage.clear();
    navigate("/");
  };

  const openPdf = () => {
    var URL = userManualDownloadUrl;
    window.open(URL, null);
  };

  const toggleMobileMenu = () => {
    setMobileMenuOpen(!isMobileMenuOpen);
  };

  const toggleMobileMenu2 = () => {
    setMobileMenuOpen2(!isMobileMenuOpen2);
  };

  const closeMobileMenu = () => {
    setMobileMenuOpen(false);
  };

  const closeMobileMenu2 = () => {
    setMobileMenuOpen2(false);
  };

  // Exhibition From Date
  const dateString = sessionStorage.getItem("exhibitionDateFrom");
  const dateStringMoment = moment
    .utc(dateString, "DD/MM/YYYY")
    .format("DD MMMM YYYY");
  const dateObject = new Date(dateStringMoment);
  const fromDay = dateObject.getDate();
  const fromMonth = dateObject.toLocaleString("default", { month: "long" });
  const fromYear = dateObject.getFullYear();
  const fromDate = `${fromDay} ${fromMonth} ${fromYear}`;

  // Exhibition to Date
  const dateString1 = sessionStorage.getItem("exhibitionDateTo");
  const dateString1Moment = moment
    .utc(dateString1, "DD/MM/YYYY")
    .format("DD MMMM YYYY");
  const dateObject1 = new Date(dateString1Moment);
  const toDay = dateObject1.getDate();
  const toMonth = dateObject1.toLocaleString("default", { month: "long" });
  const toYear = dateObject1.getFullYear();
  const toDate = `${toDay} ${toMonth} ${toYear}`;

  // Exhibition Address
  const address = sessionStorage.getItem("ExhibitionAddressSS");

  // Logo URLs
  const exhibitionLogo = sessionStorage.getItem("ExhibitionLogoSS");
  const mainLogo = sessionStorage.getItem("MainLogoSS") || "../images/Logo_3.png";

  // Exhibition Dates
  const exhibitionFromDate = sessionStorage.getItem("ExhibitionFromDateSS");
  const exhibitionToDate = sessionStorage.getItem("ExhibitionToDateSS");

  // Profile and User Details
  const profileName = (sessionStorage.getItem("profileNameSS") || "").toUpperCase();
  const nameParts = profileName.split(' ').filter(Boolean);
  const initials = nameParts.length > 0 ? (nameParts[0][0] + (nameParts.length > 1 ? nameParts[nameParts.length - 1][0] : '')).toUpperCase() : '';
  const roleID = sessionStorage.getItem("RoleIDSS");

  // Corporate Link
  const corporateLink = sessionStorage.getItem("CorporateLinkSS") || "https://corporate.india-itme.com";


  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  useEffect(() => {
    const handleResize = () => {
      const mobile = window.innerWidth < 768;
      setIsMobile(mobile);

      // ✅ Force-close mobile menus when switching to desktop
      if (!mobile) {
        setMobileMenuOpen(false);
        setMobileMenuOpen2(false);
      }
    };

    window.addEventListener("resize", handleResize);

    // Run once on mount to sync state
    handleResize();

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    function handleClickOutside(event) {
      if (notificationRef.current && !notificationRef.current.contains(event.target)) {
        setShowNotifications(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);



  return (
    <>
      {isLoading ? <Loader></Loader> : null}

      {isMobileMenuOpen && (
        <div
          className="mobile-menu-overlay exhibitor-mobile-overlay"
          onClick={closeMobileMenu}
        ></div>
      )}


      {/* Mobile Sidebar Menu */}
      <div
        className={`mobile-sidebar-menu exhibitor-mobile-menu ${isMobileMenuOpen ? "mobile-menu-open" : ""
          }`}
      >
        <div className="mobile-menu-content p-3" style={{ backgroundColor: '#f8f9fa', height: '100%', overflowY: 'auto' }}>
          {/* Header area with Name and Close button */}
          <div className="card border-0 shadow-sm rounded-3 mb-3" style={{ backgroundColor: '#3cbba7' }}>
            <div className="card-body p-3 d-flex justify-content-between align-items-start">
              <div className="text-start">
                <div className="fw-bold text-white fs-5 lh-1 mt-1 text-uppercase">{profileName} {initials ? `(${initials})` : ''}</div>
              </div>
              <button onClick={closeMobileMenu} className="btn btn-sm btn-link text-white p-0 mt-1">
                <i className="fa fa-times fa-lg"></i>
              </button>
            </div>
          </div>

          {/* Card 1: Notifications */}
          <div className="card border-0 shadow-sm rounded-3 mb-3">
            <div className="card-body p-3">
              <div className="d-flex align-items-center mb-3 border-bottom pb-2">
                <i className="fa fa-bell-o text-success me-2"></i>
                <span className="text-muted fw-bold" style={{ fontSize: '11px', letterSpacing: '1px' }}>NOTIFICATIONS</span>
              </div>
              {notifications.length === 0 ? (
                <div className="bg-light rounded p-2 text-center text-muted small">No notifications</div>
              ) : notifications.slice(0, 2).map(n => (
                <div key={n.id} className="d-flex justify-content-between align-items-center bg-light rounded p-2 mb-2" style={{ cursor: 'pointer' }} onClick={() => { openPreview(n.id); closeMobileMenu(); }}>
                  <div className="d-flex align-items-start">
                    <div className="bg-secondary bg-opacity-10 rounded-circle d-flex align-items-center justify-content-center me-2 mt-1" style={{ width: '20px', height: '20px' }}>
                      <i className={`fa ${n.type === 'alert' ? 'fa-exclamation' : 'fa-bell-o'} text-muted`} style={{ fontSize: '10px' }}></i>
                    </div>
                    <span className="text-muted lh-sm" style={{ fontSize: '12px', fontWeight: '500' }}>
                      <span dangerouslySetInnerHTML={{ __html: n.title }}></span>
                    </span>
                  </div>
                  <span className="text-success fw-bold ms-2" style={{ fontSize: '10px', whiteSpace: 'nowrap' }}>VIEW &gt;</span>
                </div>
              ))}
            </div>
          </div>

          {/* Card 2: Exhibition Details */}
          <div className="card border-0 shadow-sm rounded-3 mb-3">
            <div className="card-body p-3">
              <div className="d-flex align-items-center mb-3 border-bottom pb-2">
                <i className="fa fa-calendar-check-o text-success me-2"></i>
                <span className="text-muted fw-bold" style={{ fontSize: '11px', letterSpacing: '1px' }}>EXHIBITION DETAILS</span>
              </div>
              <div className="mb-3 text-start">
                <div className="text-success fw-bold mb-1" style={{ fontSize: '10px', letterSpacing: '1px' }}>DATE</div>
                <div className="fw-bold text-dark" style={{ fontSize: '14px' }}>{exhibitionFromDate} - {exhibitionToDate}</div>
              </div>
              <div className="text-start">
                <div className="text-success fw-bold mb-1" style={{ fontSize: '10px', letterSpacing: '1px' }}>LOCATION</div>
                <div className="d-flex align-items-start">
                  <i className="bi bi-geo-alt text-muted mt-1 me-2"></i>
                  <span className="text-muted" style={{ fontSize: '13px', fontWeight: '500' }}>{address}</span>
                </div>
              </div>
              <div className="text-end mt-3 border-top pt-2">
                <a href={corporateLink} target="_blank" rel="noopener noreferrer" className="text-success text-decoration-none fw-bold" style={{ fontSize: '11px' }}>
                  Corporate Site <i className="bi bi-box-arrow-up-right ms-1"></i>
                </a>
              </div>
            </div>
          </div>

          {/* Card 3: Quick Links */}
          <div className="card border-0 shadow-sm rounded-3 mb-3">
            <div className="card-body p-3">
              <div className="d-flex align-items-center mb-3 border-bottom pb-2">
                <i className="bi bi-lightning-charge text-success me-2" style={{ fontSize: '16px' }}></i>
                <span className="text-muted fw-bold" style={{ fontSize: '11px', letterSpacing: '1px' }}>QUICK LINKS</span>
              </div>
              <div className="d-flex flex-column gap-2">
                {sessionStorage.getItem("RoleIDSS") == 7 && (
                  <>
                    <div className="d-flex justify-content-between align-items-center bg-light rounded p-2" style={{ cursor: 'pointer' }} onClick={() => { navigateTo("VendorRegistrationAU"); closeMobileMenu(); }}>
                      <div><i className="fa fa-user-circle-o text-muted me-2"></i> <span className="text-muted fw-bold" style={{ fontSize: '13px' }}>Profile</span></div>
                      <i className="fa fa-angle-right text-muted"></i>
                    </div>
                    <div className="d-flex justify-content-between align-items-center bg-light rounded p-2" style={{ cursor: 'pointer' }} onClick={() => { navigateTo("VendorWorkOrderList"); closeMobileMenu(); }}>
                      <div><i className="fa fa-list-alt text-muted me-2"></i> <span className="text-muted fw-bold" style={{ fontSize: '13px' }}>Scope of work</span></div>
                      <i className="fa fa-angle-right text-muted"></i>
                    </div>
                    <div className="d-flex justify-content-between align-items-center bg-light rounded p-2" style={{ cursor: 'pointer' }} onClick={() => { navigateTo("EntryPass"); closeMobileMenu(); }}>
                      <div><i className="bi bi-box-arrow-in-right text-muted me-2"></i> <span className="text-muted fw-bold" style={{ fontSize: '13px' }}>Entry Pass</span></div>
                      <i className="fa fa-angle-right text-muted"></i>
                    </div>
                    <div className="d-flex justify-content-between align-items-center bg-light rounded p-2" style={{ cursor: 'pointer' }} onClick={() => { navigateTo("ExitPass"); closeMobileMenu(); }}>
                      <div><i className="bi bi-box-arrow-right text-muted me-2"></i> <span className="text-muted fw-bold" style={{ fontSize: '13px' }}>Exit Pass</span></div>
                      <i className="fa fa-angle-right text-muted"></i>
                    </div>
                  </>
                )}
              </div>
            </div>
          </div>

          {/* Change Password Button */}
          <button
            onClick={() => { setChangePasswordOpen(true); closeMobileMenu(); }}
            className="btn w-100 border-0 mb-2 d-flex justify-content-center align-items-center"
            style={{ backgroundColor: '#3cbba7', color: 'white', padding: '12px', borderRadius: '8px', textDecoration: 'none' }}
          >
            <i className="fa fa-lock me-2"></i> Change Password
          </button>

          {/* Sign Out Button */}
          <button
            onClick={() => { closeMobileMenu(); onLogoutClick(); }}
            className="btn w-100 border-0 mb-4 d-flex justify-content-center align-items-center"
            style={{ backgroundColor: '#9ca3af', color: 'white', padding: '12px', borderRadius: '8px' }}
          >
            <i className="fa fa-power-off me-2"></i> Sign Out
          </button>
        </div>
      </div>

      {isMobileMenuOpen2 && (
        <div
          className="mobile-menu-overlay exhibitor-mobile-overlay"
          onClick={closeMobileMenu2}
        ></div>
      )}

      {/* Mobile Menu Overlay */}
      {isMobileMenuOpen2 && (
        <>

          {/* Mobile Tabs Sidebar */}
          <div className={`mobile-sidebar-menu exhibitor-mobile-menu ${isMobileMenuOpen2 ? "mobile-menu-open" : ""
            }`}>
            <div style={{ height: '100%', overflowY: 'auto', position: 'relative', backgroundColor: '#3cbba7' }}>
              <button
                onClick={closeMobileMenu2}
                className="btn btn-sm text-white position-absolute"
                style={{ top: '10px', right: '15px', background: 'transparent', border: 'none', fontSize: '28px', lineHeight: '1', padding: '0', zIndex: 1000 }}
              >
                ×
              </button>
              <div className="admin-menu-list-wrapper">
                <AdminMobileDrawer />
              </div>
            </div>

            {/* <TabComponent
              tabs={MOBILE_TABS}
              activeTab={activeTab}
              onTabChange={(tab) => {
                handleTabChange(tab);
                closeMobileMenu2();
              }}
              onSpecialClick={() => {
                closeMobileMenu2();
              }}
              isMobile
            /> */}
          </div>
        </>
      )}

      {/* app-Header */}
      <div className="app-header header sticky app-heder-with-logo mb-4 exhibitor-header pt-1">
        <div className="container-fluid main-container px-2 px-md-3">
          <div className="header-content-wrapper exhibitor-header-wrapper d-flex align-items-center justify-content-between w-100 py-2">
            {/* Logo Section */}
            <div className="side-header top-logo-almnt d-flex align-items-center justify-content-center" style={{ padding: '0', margin: '0' }}>
              <a className="header-brand1" href="index.html" style={{ display: 'flex', alignItems: 'center' }}>
                {exhibitionLogo && (
                  <img
                    src={exhibitionLogo}
                    className="header-brand-img light-logo m-0"
                    alt="logo"
                    style={{ height: "60px", objectFit: 'contain' }}
                  />
                )}
                {mainLogo && (
                  <img
                    src={mainLogo}
                    className="header-brand-img m-0"
                    alt="main logo"
                    style={{ height: "60px", objectFit: 'contain' }}
                  />
                )}
              </a>
            </div>

            {/* Left Aligned Exhibition Details and Corporate Link */}
            <div className="exhibitor-content-left flex-grow-1 mx-3 d-none d-md-block">
              <div className="exhibitor-event-info">
                <h5 className="exhibitor-event-dates mb-0 text-white" style={{ fontSize: '14px' }}>
                  {exhibitionFromDate} - {exhibitionToDate}
                </h5>
                <p className="exhibitor-event-address mb-0 text-white-50" style={{ fontSize: '12px' }}>{address}</p>
              </div>
            </div>

            {/* Desktop Profile - Hidden on mobile */}
            <div className="desktop-profile exhibitor-desktop-profile d-none d-lg-block">
              <div className="dropdown profile-1 exhibitor-profile-dropdown d-flex align-items-center mt-2">
                {/* Network Connectivity */}
                <NetworkStatusIndicator className="me-3" />

                {/* Corporate Site Button */}
                <a
                  href={corporateLink}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="btn btn-sm btn-outline-light rounded-pill me-4"
                  style={{ fontWeight: '500', padding: '5px 15px' }}
                >
                  Corporate Site
                </a>

                {/* NOTIFICATION BELL */}
                <div className="notification-bell-wrapper me-3" ref={notificationRef} style={{ marginTop: '4px' }}>
                  <i
                    className="fa fa-bell fa-lg text-white"
                    onClick={() => setShowNotifications(!showNotifications)}
                    style={{ cursor: 'pointer' }}
                  ></i>
                  {unreadCount > 0 && <span className="notification-badge">{unreadCount}</span>}
                  {showNotifications && (
                    <div className="notification-dropdown shadow">
                      <div className="notification-dropdown-header">
                        <span>Notifications</span>
                        {unreadCount > 0 && <button className="mark-all-read-btn" onClick={markAllRead}>Mark all as read</button>}
                      </div>
                      {notifications.length === 0 ? (
                        <div className="notification-empty"><i className="fa fa-bell-slash-o"></i><br />No notifications</div>
                      ) : notifications.slice(0, 3).map(n => (
                        <div key={n.id} className={`notification-item${n.unread ? " unread" : ""}`}>
                          <span className={`notification-item-icon ${n.type}`}>
                            {n.initial}
                          </span>
                          <div className="notification-item-content" style={{ flex: 1 }}>
                            <div className="notification-item-title">{n.title}</div>
                            <NotificationMeta notification={n} />
                            {n.time && <div className="notification-item-time">{n.time}</div>}
                          </div>
                          <span className="notification-eye-btn" title="Preview" onClick={() => openPreview(n.id)}><i className="fa fa-eye"></i></span>
                        </div>
                      ))}
                      <div className="notification-dropdown-footer" style={{ cursor: 'pointer' }} onClick={openDrawer}>View all notifications</div>
                    </div>
                  )}
                </div>
                {sessionStorage.getItem("RoleIDSS") != 7 && (
                  <>
                    <a
                      href="javascript:void(0)"
                      data-bs-toggle="dropdown"
                      aria-expanded="false"
                      className="exhibitor-profile-trigger"
                    >
                      <span className="user-in exhibitor-profile-name">
                        {profileName}
                      </span>
                    </a>
                    <div className="dropdown-menu dropdown-menu-end dropdown-menu-arrow exhibitor-dropdown-menu">
                      <div className="exhibitor-dropdown-header">
                        <div className="exhibitor-dropdown-user">
                          {profileName}
                        </div>
                      </div>
                      <li className="dropdown-item p-2 hover-bg-light" style={{ borderBottom: "1px solid #f0f0f0" }}>
                        <button
                          onClick={() => { setChangePasswordOpen(true); }}
                          className="text-dark d-flex align-items-center bg-transparent border-0 w-100 text-start"
                          style={{ padding: '8px 12px', fontSize: '14px', textDecoration: 'none' }}
                        >
                          <i className="fa fa-lock me-2" style={{ color: '#3cbba7', width: '16px' }}></i> Change Password
                        </button>
                      </li>
                      <div className="exhibitor-dropdown-divider"></div>
                      <a
                        className="dropdown-item exhibitor-dropdown-item exhibitor-logout-item"
                        onClick={() => onLogoutClick()}
                      >
                        <i
                          className="fa fa-sign-out exhibitor-dropdown-icon"
                          aria-hidden="true"
                        ></i>
                        Sign out
                      </a>
                    </div>
                  </>
                )}
              </div>
            </div>

            {/* Mobile Right Icons - Wrapped to stick to the right edge */}
            <div className="mobile-right-icons d-flex align-items-center ms-auto d-lg-none gap-2 pe-1">
              {/* Mobile Network Connectivity */}
              <NetworkStatusIndicator compact />

              {/* Mobile Notification Bell */}
              <div className="mobile-toggle exhibitor-mobile-toggle">
                <div className="notification-bell-wrapper" ref={!isMobile ? null : notificationRef} style={{ padding: '3px' }}>
                  <i
                    className="fa fa-bell fa-lg text-white"
                    onClick={() => setShowNotifications(!showNotifications)}
                    style={{ cursor: 'pointer' }}
                  ></i>
                  {unreadCount > 0 && <span className="notification-badge">{unreadCount}</span>}
                  {showNotifications && isMobile && (
                    <div className="notification-dropdown shadow">
                      <div className="notification-dropdown-header">
                        <span>Notifications</span>
                        {unreadCount > 0 && <button className="mark-all-read-btn" onClick={markAllRead}>Mark all as read</button>}
                      </div>
                      {notifications.length === 0 ? (
                        <div className="notification-empty">No notifications</div>
                      ) : notifications.map(n => (
                        <div key={n.id} className={`notification-item${n.unread ? " unread" : ""}`}>
                          <span className={`notification-item-icon ${n.type}`}>
                            {n.initial}
                          </span>
                          <div className="notification-item-content" style={{ flex: 1 }}>
                            <div className="notification-item-title">{n.title}</div>
                            <NotificationMeta notification={n} />
                            {n.time && <div className="notification-item-time">{n.time}</div>}
                          </div>
                          <span className="notification-eye-btn" title="Preview" onClick={() => openPreview(n.id)}><i className="fa fa-eye"></i></span>
                        </div>
                      ))}
                      <div className="notification-dropdown-footer" style={{ cursor: 'pointer' }} onClick={openDrawer}>View all notifications</div>
                    </div>
                  )}
                </div>
              </div>

              {/* Mobile Toggle Button */}
              <div className="mobile-toggle exhibitor-mobile-toggle">
                <button
                  onClick={toggleMobileMenu}
                  className="exhibitor-menu-toggle-btn text-white" style={{ padding: '3px' }}>
                  <span className="material-symbols-outlined">
                    person
                  </span>
                </button>
              </div>

              {(roleID == 2 || roleID == 5 || roleID == 6) && (
                <div className="mobile-toggle exhibitor-mobile-toggle">
                  <button
                    onClick={toggleMobileMenu2}
                    className="exhibitor-menu-toggle-btn"
                  >
                    <span className="exhibitor-menu-toggle-bar"></span>
                    <span className="exhibitor-menu-toggle-bar"></span>
                    <span className="exhibitor-menu-toggle-bar"></span>
                  </button>
                </div>
              )}
            </div>

          </div>

          {/* Absolute Marquee at the bottom of the header */}
          <div className="marquee-text" style={{ position: 'absolute', bottom: '-4px', left: '0', width: '100%', pointerEvents: 'none', margin: '0' }}>
            <marquee
              behavior="scroll"
              direction="left"
              scrollamount="5"
              ref={marqueeRef}
              onMouseOver={() => marqueeRef.current?.stop()}
              onMouseOut={() => marqueeRef.current?.start()}
              style={{ pointerEvents: 'auto', marginBottom: '0' }}
            >
              <b>Disclaimer and Ownership:</b> {disclaimer}
            </marquee>
          </div>
        </div>
      </div>
      {/* /app-Header */}
      <NotificationDrawer show={showDrawer} notifications={notifications} unreadCount={unreadCount} markAllRead={markAllRead} openPreview={openPreview} onClose={closeDrawer} />
      <NotificationPreviewModal notification={previewItem} onClose={closePreview} />

      {isChangePasswordOpen && (
        <ChangePassword2 onClose={() => setChangePasswordOpen(false)} />
      )}
    </>
  );
};

export default HeaderWithLogo;
